(function () {
  if (window.__swx3dInit) return;
  window.__swx3dInit = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  function mount(root) {
    if (root.dataset.swx3dReady) return;
    root.dataset.swx3dReady = '1';
    var pose = root.dataset.pose || 'hover';
    var canvas = root.querySelector('[data-swx3d-canvas]');
    var visible = false, running = false, hovering = false, tapped = false;
    var px = 0, py = 0, spinV = 0, spin = 0, dragging = false, lastX = 0, moved = 0;
    var S = { lid: pose === 'open' ? 1 : 0, buds: pose === 'open' ? 1 : 0, rx: 0, ry: 0 };

    root.addEventListener('pointermove', function (e) {
      var r = root.getBoundingClientRect();
      px = ((e.clientX - r.left) / r.width - 0.5) * 2;
      py = ((e.clientY - r.top) / r.height - 0.5) * 2;
      if (dragging) { var dx = e.clientX - lastX; lastX = e.clientX; spinV += dx * 0.0035; moved += Math.abs(dx); }
      kick();
    });
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovering = true; kick(); } });
    root.addEventListener('pointerleave', function () { hovering = false; px = py = 0; dragging = false; kick(); });
    root.addEventListener('pointerdown', function (e) { dragging = true; lastX = e.clientX; moved = 0; });
    window.addEventListener('pointerup', function () {
      if (dragging && moved < 6) { tapped = !tapped; }
      dragging = false; kick();
    });

    var tick;
    function kick() { if (tick) tick(); }

    function scrollProgress() {
      var r = root.getBoundingClientRect(), vh = window.innerHeight;
      return clamp((vh - r.top) / (vh + r.height), 0, 1);
    }

    function boot() {
      window.swxLoad3D(root).then(function (gltf) { init(gltf); }).catch(function () { root.classList.add('swx3d--off'); });
    }
    var io = new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      if (visible && !root.dataset.swx3dBooted) { root.dataset.swx3dBooted = '1'; boot(); }
      kick();
    }, { rootMargin: '300px 0px' });
    io.observe(root);

    function init(gltf) {
      var renderer;
      try { renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true }); }
      catch (e) { root.classList.add('swx3d--off'); return; }
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.5));
      renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.1;

      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(30, 1, 0.1, 200);
      camera.position.set(0, 1.3, 8.6);
      camera.lookAt(0, 0.15, 0);
      var pmrem = new THREE.PMREMGenerator(renderer);
      scene.environment = pmrem.fromScene(new THREE.RoomEnvironment(), 0.04).texture;
      scene.add(new THREE.HemisphereLight(0xdfe9ff, 0x0a0e18, 0.35));
      var key = new THREE.DirectionalLight(0xffffff, 2.2); key.position.set(5, 8, 6); scene.add(key);
      var rim = new THREE.DirectionalLight(0x2fe39b, 1.8); rim.position.set(-4, 5, -6); scene.add(rim);

      var HINGE = new THREE.Vector3(0, 0.13, -0.995), LID_CLOSED = 2.007;
      var model = gltf.scene.clone(true);
      var lid = model.getObjectByName('BoFsEvBGaAjKkRU');
      var budR = model.getObjectByName('szusrxTxeDnOCPF');
      var budL = model.getObjectByName('iauArCIBpqmQwBK');
      model.traverse(function (o) { if (o.isMesh && o.material) o.material.envMapIntensity = 1.25; });
      model.updateMatrixWorld(true);
      var b = new THREE.Box3().setFromObject(model), sz = b.getSize(new THREE.Vector3());
      model.scale.setScalar(3.2 / Math.max(sz.x, sz.y, sz.z));
      model.updateMatrixWorld(true);
      b = new THREE.Box3().setFromObject(model);
      model.position.sub(b.getCenter(new THREE.Vector3()));
      model.updateMatrixWorld(true);

      var rig = new THREE.Group(); scene.add(rig);
      rig.add(model);
      var lidPivot = new THREE.Group();
      lidPivot.position.copy(model.localToWorld(HINGE.clone()));
      rig.add(lidPivot); lidPivot.attach(lid);
      rig.attach(budL); rig.attach(budR);
      var budL0 = budL.position.clone(), budR0 = budR.position.clone();
      var rzL = budL.rotation.z, rzR = budR.rotation.z;

      function resize() {
        var w = root.clientWidth, h = root.clientHeight;
        if (!w || !h) return;
        renderer.setSize(w, h, false);
        camera.aspect = w / h;
        camera.updateProjectionMatrix();
      }
      resize();
      window.addEventListener('resize', function () { resize(); kick(); });

      var t0 = performance.now();
      function frame(now) {
        running = false;
        if (!visible) return;
        var t = (now - t0) / 1000;
        var goalLid, goalBuds, baseRy;
        if (pose === 'scroll') {
          var p = scrollProgress();
          goalLid = clamp((p - 0.2) / 0.35, 0, 1);
          goalBuds = clamp((p - 0.45) / 0.3, 0, 1);
          baseRy = -0.6 + p * 1.2;
        } else if (pose === 'open') {
          goalLid = 1; goalBuds = 1; baseRy = Math.sin(t * 0.35) * 0.45;
        } else if (pose === 'closed') {
          goalLid = (hovering || tapped) ? 1 : 0; goalBuds = 0; baseRy = t * 0.4;
        } else {
          var on = hovering || tapped;
          goalLid = on ? 1 : 0; goalBuds = on ? 1 : 0; baseRy = Math.sin(t * 0.4) * 0.5;
        }
        if (reduce) baseRy = 0.35;
        spin += spinV; spinV *= 0.94;
        var k = 0.08;
        S.lid += (goalLid - S.lid) * k;
        S.buds += (goalBuds - S.buds) * (k * 0.8);
        S.rx += ((py * 0.18) - S.rx) * 0.08;
        S.ry += ((baseRy + px * 0.5) - S.ry) * 0.08;

        rig.rotation.set(0.12 + S.rx, S.ry + spin, 0);
        rig.position.y = Math.sin(t * 1.3) * 0.08 - S.buds * 0.35;
        lidPivot.rotation.x = LID_CLOSED * (1 - S.lid);
        var lift = S.buds * 1.55 + Math.sin(t * 2) * 0.05 * S.buds;
        budL.visible = budR.visible = S.lid > 0.5;
        budL.position.set(budL0.x - S.buds * 0.35, budL0.y - 1.45 + lift, budL0.z);
        budR.position.set(budR0.x + S.buds * 0.35, budR0.y - 1.45 + lift, budR0.z);
        budL.rotation.z = rzL + S.buds * 0.2; budR.rotation.z = rzR - S.buds * 0.2;
        renderer.render(scene, camera);
        if (!root.classList.contains('is-ready')) root.classList.add('is-ready');
        schedule();
      }
      function schedule() { if (!running && visible) { running = true; requestAnimationFrame(frame); } }
      tick = schedule;
      schedule();
    }
  }

  function bootAll() { document.querySelectorAll('[data-swx-case3d]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll); else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
